/** @format */

import { TRoom } from '@/ducks/room/declarations';
import { selectorAvailabilityArray } from '@/ducks/shared/selectors';
import { useAppSelector } from '@/redux/hooks';
import { utilityFilterAvailabilityArray } from '@/utils/helpers/utilityFilterAvailabilityArray';
import React, { useMemo } from 'react';
import MapDesktop from './Map';

interface Props {
  room: TRoom;
  url: string | null;
}

const RoomMap: React.FC<Props> = ({ room, url }) => {
  const availabilityArray = useAppSelector(selectorAvailabilityArray);
  const filteredAvailabilityArray = utilityFilterAvailabilityArray(availabilityArray, [room]);
  const coordinates = useMemo(() => {
    return {
      latitude: room.position.latitude,
      longitude: room.position.longitude,
    };
  }, [room]);

  return (
    <MapDesktop room={room} coordinates={coordinates} filteredAvailabilityArray={filteredAvailabilityArray} url={url} />
  );
};

export default RoomMap;
